(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-review-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.dlRscInit) return; root.dataset.dlRscInit = '1';
      var track = root.querySelector('[data-dl-rsc-track]'); if (!track) return;
      var n = track.children.length, bar = root.querySelector('[data-dl-rsc-bar]');
      function index() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function paint() { if (bar) bar.style.left = (index() * 100 / n) + '%'; }
      var prev = root.querySelector('[data-dl-rsc-prev]'), next = root.querySelector('[data-dl-rsc-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); } });
    }
    function all() { document.querySelectorAll('[data-dl-rsc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-volume-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dl-sale-end]').forEach(function(el){
    var d = el.getAttribute('data-dl-sale-end'); if(!d) return;
    var end = new Date(d + 'T23:59:59'); if(!isNaN(end) && Date.now() > end.getTime()) el.style.display = 'none';
  });
  document.querySelectorAll('[data-dl-vs-end]').forEach(function(el){
    var d = el.getAttribute('data-dl-vs-end'); if(!d) return;
    var end = new Date(d + 'T23:59:59'); if(!isNaN(end) && Date.now() > end.getTime()) el.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
